import React from "react";
import "./Footer.css";
import logo from "../assets/KI.svg";

const prefilledMsg = encodeURIComponent(
  `Hello, I want to find out more about your insurance product!`
);
const whatsappNumber = "+233500490065";
const whatsappLink = `https://wa.me/${whatsappNumber.replace('+','')}/?text=${prefilledMsg}`;

const Footer = ({ className = "" }) => {
  return (
    <footer className={`footer-container ${className}`}>
      <div className="container footer-content">
        {/* LOGO SECTION */}
        <div className="footer-logo">
          <img src={logo} alt="Kora Insurance Logo" />
        </div>

        {/* ABOUT US SECTION */}
        <div className="footer-section about">
          <h3>About</h3>
          <p><a href="/about">About Us</a></p>
          <p><a href="/terms-and-conditions">Terms & Conditions</a></p>
        </div>

        {/* CONTACT SECTION */}
        <div className="footer-section contact">
          <h3>Contact</h3>
          <p>Email: <a href="mailto:hello@summerhealth.io">hello@summerhealth.io</a></p>
          <p>
            Tel/WhatsApp: <a 
              href={whatsappLink} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn btn-whatsapp"
            >
              +233 500 490 065
            </a>
          </p>
        </div>

        {/* FOLLOW US SECTION */}
        <div className="footer-section follow-us">
          <h3>Follow Us</h3>
          <div className="social-links">
            <a href="https://facebook.com/trysummerhealth" target="_blank" rel="noopener noreferrer">Facebook</a>
            <a href="https://twitter.com/trysummerhealth" target="_blank" rel="noopener noreferrer">Twitter</a>
            <a href="https://linkedin.com/company/summerhealth" target="_blank" rel="noopener noreferrer">LinkedIn</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div>
          &copy; <span id="currentYear">{new Date().getFullYear()}</span> Kora Insurance. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
